import apiCore from '../../utils/api-core';

export default {
	getAllConversations(query) {
		return apiCore.get(`/api/v1/userbot/conversations?${query}`);
	},

	getAllContactsWithConversation(data, query) {
		return apiCore.post(`/api/v1/contacts/conversation?${query}`, data);
	},

	getConversationByFilters(data, query) {
		return apiCore.post(`/api/v2/contacts/conversation?${query}`, data);
	},

	getConvoThreads(contactId, query) {
		return apiCore.get(`/api/v1/conversations/${contactId}/threads?${query}`);
	},

	sendNew(body) {
		return apiCore.post('/api/v1/conversation/sendnew', body);
	},

	sendReply(body) {
		return apiCore.post('/api/v1/conversation/send', body);
	},
	sendInterviewScheduling(body){
		return apiCore.post('/api/v1/conversation/send/scheduling', body);
	},
	sendToWebchat(body) {
		return apiCore.post('/hooks/webchat', body);
	},

	getConvoByBots(query, botId) {
		return apiCore.get(`/api/v1/bots/${botId}/conversations?${query}`);
	},

	getConvoByDepts(query, deptId) {
		return apiCore.get(`/api/v1/departments/${deptId}/conversations?${query}`);
	},

	getTemplates() {
		return apiCore.get('/api/v1/templates');
	},
};
